// extracted by mini-css-extract-plugin
export default {"controls":"Stream_controls__AiZy2","record-btn":"Stream_record-btn__N-EbK","dot":"Stream_dot__sv7Lp"};